import { z } from "zod";

const translationPath = "chatBot.page.service.ticketServiceMessage.errors.";

const ticketServiceSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional(),
  },
  { invalid_type_error: translationPath + "ticket_service" }
);

const targetSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional(),
  },
  { invalid_type_error: translationPath + "target" }
);

export const newTicketServiceMessageSchema = z.object({
  ticketService: ticketServiceSchema,
  target: targetSchema,
  messageType: z.string().min(1, translationPath + "message_type"),
  message: z.string().min(1, translationPath + "message"),
});

export type TNewTicketServiceMessageForm = z.infer<
  typeof newTicketServiceMessageSchema
>;
